module.exports = __webpack_public_path__ + "static/media/mfzj.7dfa1429.png";